import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import uuid from 'uuid';
import validator from 'validator';
import {
  Card,
  CardHeader,
  CardText,
  CardTitle,
  CardActions,
} from 'material-ui/Card';
import TextField from 'material-ui/TextField';
import SelectField from 'material-ui/SelectField';
import CircularProgress from 'material-ui/CircularProgress';
import MenuItem from 'material-ui/MenuItem';
import AutoComplete from 'material-ui/AutoComplete';
import Checkbox from 'material-ui/Checkbox';
import RaisedButton from 'material-ui/RaisedButton';
import IconButton from 'material-ui/IconButton';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import CloseIcon from 'material-ui/svg-icons/action/delete';
import getLocations from '../../utils/locations';
import { theme } from '../../utils/getTheme';
import { database } from '../../utils/configureFirebase';
import JobDetailCard from '../../components/JobDetailCard';
import states from '../../utils/states';

const ContentWrapper = styled.div`
  width: 80%;
  margin: 0 auto;

  & > * + * {
    margin-top: 24px;
  }
`;

const TextFieldContainer = styled.div`
  display: flex;
  flex: wrap;
  justify-content: space-between;
  width: 100%;
`;

const CardIcon = styled.div`
  position: absolute;
  top: 12px;
  right: 16px;
  opacity: 0.54;
`;

const ContentContainer = styled.div`
  & > * {
    margin-bottom: 16px;
  }
`;

const DialogContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

class EarlyBirdCorporateEdit extends Component {
  constructor(props) {
    super(props);

    this.state = {
      id: '',
      isLoading: true,
      confirmModalOpen: false,
      companyName: '',
      companyNameErrorMessage: undefined,
      companyType: '',
      companyTypeErrorMessage: undefined,
      locationSearchText: '',
      location: '',
      website: '',
      websiteErrorMessage: undefined,
      locationDataSource: [],
      locationErrorMessage: undefined,
      companyDescription: '',
      companyDescriptionErrorMessage: undefined,
      contactShow: false,
      contacts: [],
      contactErrorMessage: undefined,
      contactName: '',
      contactNameErrorMessage: undefined,
      designation: '',
      designationErrorMessage: undefined,
      contactNumber: '',
      contactNumberErrorMessage: undefined,
      email: '',
      emailErrorMessage: undefined,
      partnership: '',
      partnershipErrorMessage: undefined,
      jobShow: false,
      jobs: [],
      jobsErrorMessage: undefined,
      jobTitle: '',
      jobTitleErrorMessage: undefined,
      jobDescription: '',
      jobDescriptionErrorMessage: undefined,
      jobLocationSearchText: '',
      jobLocation: '',
      requirements: undefined,
      requirementsErrorMessage: undefined,
      jobLocationDataSource: [],
      jobLocationErrorMessage: undefined,
      employmentType: '',
      employmentTypeErrorMessage: undefined,
      ctc: '',
      duration: '',
      durationErrorMessage: undefined,
      ctcErrorMessage: undefined,
      onlinePortal: false,
      remarks: '',
      awardShow: false,
      awards: [],
      awardsErrorMessage: undefined,
      awardName: '',
      awardNameErrorMessage: undefined,
      awardYear: '',
      awardYearErrorMessage: undefined,
      address: '',
      addressErrorMessage: undefined,
      state: '',
      stateErrorMessage: undefined,
      city: '',
      cityErrorMessage: undefined,
      pincode: '',
      pincodeErrorMessage: undefined,
      timestamp: undefined,
    };
  }

  componentDidMount() {
    const { match } = this.props;
    this.registrationRef = database.ref(`contact/corporate/${match.params.id}`);
    this.registrationRef.on('value', this.setRegistrationData);
  }

  componentWillUnmount() {
    this.registrationRef.off('value', this.setRegistrationData);
  }

  setRegistrationData = (snapshot) => {
    if (snapshot) {
      const corporate = snapshot.val();
      this.setState(() => ({
        ...corporate,
        isLoading: false,
      }));
    }
  };

  showAwardFields = () => {
    this.setState(() => ({
      awardShow: true,
    }));
  };

  cancelAward = () => {
    this.setState(() => ({
      awardShow: false,
    }));
  };

  addAward = () => {
    const { awards, awardName, awardYear } = this.state;
    let flag = false;

    if (validator.isEmpty(awardName)) {
      this.setState(() => ({
        awardNameErrorMessage: 'Award name is required',
      }));
      flag = true;
    } else {
      this.setState(() => ({
        awardNameErrorMessage: undefined,
      }));
    }

    if (validator.isEmpty(awardYear)) {
      this.setState(() => ({
        awardYearErrorMessage: 'Award year is required',
      }));
      flag = true;
    } else {
      this.setState(() => ({
        awardYearErrorMessage: undefined,
      }));
    }

    if (!flag) {
      this.setState(() => ({
        awards: [
          ...awards,
          {
            id: uuid.v4(),
            name: awardName,
            year: awardYear,
          },
        ],
        awardName: '',
        awardYear: '',
        awardShow: false,
      }));
    }
  };

  removeAward = (id) => {
    this.setState(state => ({
      awards: state.awards.filter(award => award.id !== id),
    }));
  };

  showContactFields = () => {
    this.setState(() => ({
      contactShow: true,
    }));
  };

  cancelContact = () => {
    this.setState(() => ({
      contactShow: false,
    }));
  };

  addContact = () => {
    const {
      contactName,
      designation,
      contactNumber,
      email,
      contacts,
    } = this.state;
    let flag = false;

    if (validator.isEmpty(contactName)) {
      this.setState(() => ({
        contactNameErrorMessage: 'Name of Contact is required',
      }));
      flag = true;
    } else {
      this.setState(() => ({
        contactNameErrorMessage: undefined,
      }));
    }

    if (validator.isEmpty(designation)) {
      this.setState(() => ({
        designationErrorMessage: 'Designation is required',
      }));
      flag = true;
    } else {
      this.setState(() => ({
        designationErrorMessage: undefined,
      }));
    }

    if (validator.isEmpty(contactNumber)) {
      this.setState(() => ({
        contactNumberErrorMessage: 'Contact number is required',
      }));
      flag = true;
    } else if (!validator.isMobilePhone(contactNumber, 'en-IN')) {
      this.setState(() => ({
        contactNumberErrorMessage: 'Incorrect format of Contact Number',
      }));
      flag = true;
    } else {
      this.setState(() => ({
        contactNumberErrorMessage: undefined,
      }));
    }

    if (validator.isEmpty(email)) {
      this.setState(() => ({
        emailErrorMessage: 'Email is required',
      }));
      flag = true;
    } else if (!validator.isEmail(email)) {
      this.setState(() => ({
        emailErrorMessage: 'Incorrect format of Email',
      }));
      flag = true;
    } else {
      this.setState(() => ({
        emailErrorMessage: undefined,
      }));
    }

    if (!flag) {
      this.setState(() => ({
        contacts: [
          ...contacts,
          {
            id: uuid.v4(),
            name: contactName,
            designation,
            contact: contactNumber,
            email,
          },
        ],
        contactName: '',
        designation: '',
        contactNumber: '',
        email: '',
        contactShow: false,
      }));
    }
  };

  removeContact = (id) => {
    this.setState(state => ({
      contacts: state.contacts.filter(contact => contact.id !== id),
    }));
  };

  showJobfields = () => {
    this.setState(() => ({
      jobShow: true,
    }));
  };

  cancelJob = () => {
    this.setState(() => ({
      jobShow: false,
    }));
  };

  addJob = () => {
    const {
      jobTitle,
      jobDescription,
      jobLocation,
      employmentType,
      requirements,
      ctc,
      duration,
    } = this.state;
    let flag = false;

    if (validator.isEmpty(jobTitle)) {
      this.setState(() => ({
        jobTitleErrorMessage: 'Job Title is required',
      }));
      flag = true;
    } else {
      this.setState(() => ({
        jobTitleErrorMessage: undefined,
      }));
    }

    if (validator.isEmpty(jobDescription)) {
      this.setState(() => ({
        jobDescriptionErrorMessage: 'Description of the company is required',
      }));
      flag = true;
    } else {
      this.setState(() => ({
        jobDescriptionErrorMessage: undefined,
      }));
    }

    if (typeof requirements === 'undefined') {
      this.setState(() => ({
        requirementsErrorMessage: 'Number of requirements is required',
      }));
      flag = true;
    } else {
      this.setState(() => ({
        requirementsErrorMessage: undefined,
      }));
    }

    if (validator.isEmpty(jobLocation)) {
      this.setState(() => ({
        jobLocationErrorMessage: 'Job Location is required',
      }));
      flag = true;
    } else {
      this.setState(() => ({
        jobDescriptionErrorMessage: undefined,
      }));
    }

    if (validator.isEmpty(employmentType)) {
      this.setState(() => ({
        employmentTypeErrorMessage: 'Description of the company is required',
      }));
      flag = true;
    } else {
      this.setState(() => ({
        employmentTypeErrorMessage: undefined,
      }));
    }

    if (validator.isEmpty(ctc)) {
      this.setState(() => ({
        ctcErrorMessage: 'This field is required.',
      }));
      flag = true;
    } else {
      this.setState(() => ({
        ctcErrorMessage: undefined,
      }));
    }

    if (employmentType === 'Internship' && validator.isEmpty(duration)) {
      this.setState(() => ({
        durationErrorMessage: 'Duration of Internship is required.',
      }));
      flag = true;
    } else {
      this.setState(() => ({
        durationErrorMessage: undefined,
      }));
    }

    if (!flag) {
      this.setState(state => ({
        jobs: [
          ...state.jobs,
          {
            id: uuid.v4(),
            jobTitle,
            jobDescription,
            requirements,
            jobLocation,
            employmentType,
            ctc,
            duration,
          },
        ],
        jobTitle: '',
        jobDescription: '',
        requirements: '',
        jobLocation: '',
        jobLocationSearchText: '',
        employmentType: '',
        ctc: '',
        duration: '',
        jobShow: false,
        jobsErrorMessage: undefined,
      }));
    }
  };

  removeJob = (id) => {
    this.setState(state => ({
      jobs: state.jobs.filter(job => job.id !== id),
    }));
  };

  validateInfo = () => {
    const {
      companyName,
      companyType,
      companyDescription,
      address,
      state,
      city,
      pincode,
      website,
      jobs,
      contacts,
      partnership,
    } = this.state;
    let flag = false;

    if (validator.isEmpty(companyName)) {
      this.setState(() => ({
        companyNameErrorMessage: 'Name of company is required',
      }));
      flag = true;
    } else {
      this.setState(() => ({
        companyNameErrorMessage: undefined,
      }));
    }

    if (validator.isEmpty(companyType)) {
      this.setState(() => ({
        companyTypeErrorMessage: 'Type of company is required',
      }));
      flag = true;
    } else {
      this.setState(() => ({
        companyTypeErrorMessage: undefined,
      }));
    }

    if (validator.isEmpty(companyDescription)) {
      this.setState(() => ({
        companyDescriptionErrorMessage:
          'Description of the company is required',
      }));
      flag = true;
    } else {
      this.setState(() => ({
        companyDescriptionErrorMessage: undefined,
      }));
    }

    if (validator.isEmpty(address)) {
      this.setState(() => ({
        addressErrorMessage: 'Address is required',
      }));
      flag = true;
    } else {
      this.setState(() => ({
        addressErrorMessage: undefined,
      }));
    }

    if (validator.isEmpty(state)) {
      this.setState(() => ({
        stateErrorMessage: 'State is required',
      }));
      flag = true;
    } else {
      this.setState(() => ({
        stateErrorMessage: undefined,
      }));
    }

    if (validator.isEmpty(city)) {
      this.setState(() => ({
        cityErrorMessage: 'City is required',
      }));
      flag = true;
    } else {
      this.setState(() => ({
        cityErrorMessage: undefined,
      }));
    }

    if (validator.isEmpty(pincode)) {
      this.setState(() => ({
        pincodeErrorMessage: 'Pincode is required',
      }));
      flag = true;
    } else if (!validator.isNumeric(pincode)) {
      this.setState(() => ({
        pincodeErrorMessage: 'Pincode should be numeric',
      }));
      flag = true;
    } else {
      this.setState(() => ({
        pincodeErrorMessage: undefined,
      }));
    }

    if (validator.isEmpty(website)) {
      this.setState(() => ({
        websiteErrorMessage: 'Website is required',
      }));
      flag = true;
    } else {
      this.setState(() => ({
        websiteErrorMessage: undefined,
      }));
    }

    if (validator.isEmpty(partnership)) {
      this.setState(() => ({
        partnershipErrorMessage: 'Partnership type is required',
      }));
      flag = true;
    } else {
      this.setState(() => ({
        partnershipErrorMessage: undefined,
      }));
    }

    if (partnership === 'Campus Partner' && jobs.length === 0) {
      this.setState(() => ({
        jobsErrorMessage: 'Atleast one job is required',
      }));
      flag = true;
    } else {
      this.setState(() => ({
        jobsErrorMessage: undefined,
      }));
    }

    if (contacts.length === 0) {
      this.setState(() => ({
        contactErrorMessage: 'Atleast one contact information is required',
      }));
      flag = true;
    } else {
      this.setState(() => ({
        contactErrorMessage: undefined,
      }));
    }
    if (flag) {
      this.moveToTop();
    }
    return flag;
  };

  updateCorporate = () => {
    this.setState(() => ({
      isLoading: true,
    }));
    const { match, history } = this.props;
    const {
      id,
      companyName,
      companyType,
      companyDescription,
      website,
      contacts,
      partnership,
      jobs,
      onlinePortal,
      awards,
      remarks,
      address,
      state,
      city,
      pincode,
      timestamp,
    } = this.state;

    const data = {
      id,
      companyName,
      companyType,
      companyDescription,
      website,
      contacts,
      partnership,
      onlinePortal,
      jobs,
      awards,
      remarks,
      address,
      state,
      city,
      pincode,
      timestamp,
    };

    const databaseRef = database
      .ref()
      .child(`contact/corporate/${match.params.id}`);

    databaseRef
      .update({
        ...data,
      })
      .then(() => {
        history.push('/campuscape/corporate');
      });
  };

  openConfirmModal = () => {
    this.setState(() => ({
      confirmModalOpen: true,
    }));
  };

  closeConfirmModal = () => {
    this.setState(() => ({
      confirmModalOpen: false,
    }));
  };

  moveToTop = () => {
    document
      .getElementById('headerDiv')
      .scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'end' });
  };

  render() {
    const {
      isLoading,
      companyName,
      companyNameErrorMessage,
      companyType,
      companyTypeErrorMessage,
      website,
      websiteErrorMessage,
      companyDescription,
      companyDescriptionErrorMessage,
      awards,
      contactShow,
      contacts,
      contactErrorMessage,
      contactName,
      contactNameErrorMessage,
      designation,
      designationErrorMessage,
      contactNumber,
      contactNumberErrorMessage,
      email,
      emailErrorMessage,
      partnership,
      partnershipErrorMessage,
      jobShow,
      jobs,
      jobsErrorMessage,
      jobTitle,
      jobTitleErrorMessage,
      jobDescription,
      jobDescriptionErrorMessage,
      jobLocationSearchText,
      jobLocationDataSource,
      jobLocationErrorMessage,
      requirements,
      requirementsErrorMessage,
      employmentType,
      employmentTypeErrorMessage,
      ctc,
      ctcErrorMessage,
      duration,
      durationErrorMessage,
      onlinePortal,
      remarks,
      awardShow,
      awardName,
      awardNameErrorMessage,
      awardYear,
      awardYearErrorMessage,
      address,
      addressErrorMessage,
      state,
      stateErrorMessage,
      city,
      cityErrorMessage,
      pincode,
      pincodeErrorMessage,
      confirmModalOpen,
      // isLoading,
    } = this.state;
    return (
      <div>
        {isLoading ? (
          <ContentContainer>
            <DialogContent>
              <CircularProgress />
            </DialogContent>
          </ContentContainer>
        ) : (
          <div id="headerDiv">
            <ContentWrapper>
              <Card>
                <CardTitle title="Company Information" />
                <CardText style={{ paddingTop: 0 }}>
                  <TextField
                    floatingLabelText="Name*"
                    fullWidth
                    hintText="Name of the Company"
                    value={companyName}
                    onChange={(_, value) => {
                      this.setState(() => ({
                        companyName: value,
                      }));
                    }}
                    errorText={companyNameErrorMessage}
                  />

                  <SelectField
                    floatingLabelText="Category *"
                    fullWidth
                    value={companyType}
                    onChange={(_, index, value) => {
                      this.setState(() => ({
                        companyType: value,
                      }));
                    }}
                    errorText={companyTypeErrorMessage}
                  >
                    <MenuItem value="IT" primaryText="IT" />
                    <MenuItem value="Non - IT" primaryText="Non - IT" />
                  </SelectField>

                  <TextField
                    floatingLabelText="Address *"
                    hintText="Enter the address of the college"
                    fullWidth
                    value={address}
                    onChange={(_, value) => {
                      this.setState(() => ({
                        address: value,
                      }));
                    }}
                    errorText={addressErrorMessage}
                  />

                  <TextFieldContainer>
                    <SelectField
                      floatingLabelText="State *"
                      hintText="State is required"
                      style={{ width: '48%' }}
                      fullWidth
                      value={state}
                      onChange={(_, index, value) => {
                        this.setState(() => ({
                          state: value,
                        }));
                      }}
                      errorText={stateErrorMessage}
                    >
                      {states.map(countryState => (
                        <MenuItem
                          key={countryState.name}
                          primaryText={countryState.name}
                          value={countryState.value}
                        />
                      ))}
                    </SelectField>

                    <TextField
                      floatingLabelText="City *"
                      hintText="Enter the city of the college"
                      style={{ width: '48%' }}
                      value={city}
                      onChange={(_, value) => {
                        this.setState(() => ({
                          city: value,
                        }));
                      }}
                      errorText={cityErrorMessage}
                    />
                  </TextFieldContainer>

                  <TextField
                    floatingLabelText="Pincode"
                    hintText="Enter the pincode in numeric form"
                    style={{ width: '48%' }}
                    value={pincode}
                    onChange={(_, value) => {
                      this.setState(() => ({
                        pincode: value,
                      }));
                    }}
                    errorText={pincodeErrorMessage}
                  />

                  <TextField
                    floatingLabelText="Website *"
                    hintText="Website of the company"
                    fullWidth
                    multiLine
                    value={website}
                    onChange={(_, value) => {
                      this.setState(() => ({
                        website: value,
                      }));
                    }}
                    errorText={websiteErrorMessage}
                  />

                  <TextField
                    floatingLabelText="About the Company *"
                    hintText="Enter brief description about the company"
                    fullWidth
                    multiLine
                    value={companyDescription}
                    onChange={(_, value) => {
                      this.setState(() => ({
                        companyDescription: value,
                      }));
                    }}
                    errorText={companyDescriptionErrorMessage}
                  />
                </CardText>

                <CardTitle
                  title="Point of Contact *"
                  subtitle={contactErrorMessage}
                  subtitleColor={theme.accent1Color}
                />
                <CardText style={{ paddingTop: 0 }}>
                  <ContentContainer>
                    {contacts.map(contact => (
                      <Card key={contact.id} style={{ position: 'relative' }}>
                        <CardHeader
                          title={contact.name}
                          subtitle={`${contact.designation} | ${contact.contact} `}
                        />
                        <CardIcon>
                          <IconButton>
                            <CloseIcon
                              color={theme.primary1Color}
                              onTouchTap={() => {
                                this.removeContact(contact.id);
                              }}
                            />
                          </IconButton>
                        </CardIcon>
                      </Card>
                    ))}
                  </ContentContainer>
                  {contactShow ? (
                    <div>
                      <TextFieldContainer>
                        <TextField
                          floatingLabelText="Name of Contact *"
                          hintText="Name of Contact"
                          style={{ width: '48%' }}
                          value={contactName}
                          onChange={(_, value) => {
                            this.setState(() => ({
                              contactName: value,
                            }));
                          }}
                          errorText={contactNameErrorMessage}
                        />

                        <TextField
                          floatingLabelText="Designation *"
                          hintText="Head HR, HR"
                          style={{ width: '48%' }}
                          value={designation}
                          onChange={(_, value) => {
                            this.setState(() => ({
                              designation: value,
                            }));
                          }}
                          errorText={designationErrorMessage}
                        />
                      </TextFieldContainer>

                      <TextFieldContainer>
                        <TextField
                          floatingLabelText="Contact Number *"
                          hintText="Enter 10 digit phone number"
                          style={{ width: '48%' }}
                          value={contactNumber}
                          onChange={(_, value) => {
                            this.setState(() => ({
                              contactNumber: value,
                            }));
                          }}
                          errorText={contactNumberErrorMessage}
                        />

                        <TextField
                          floatingLabelText="Email Address *"
                          hintText="Enter company email address"
                          style={{ width: '48%' }}
                          value={email}
                          onChange={(_, value) => {
                            this.setState(() => ({
                              email: value,
                            }));
                          }}
                          errorText={emailErrorMessage}
                        />
                      </TextFieldContainer>
                      <CardActions>
                        <RaisedButton
                          label="Save"
                          primary
                          onTouchTap={this.addContact}
                        />

                        <FlatButton
                          label="Cancel"
                          primary
                          onTouchTap={this.cancelContact}
                        />
                      </CardActions>
                    </div>
                  ) : (
                    <CardActions style={{ marginTop: '8px' }}>
                      <RaisedButton
                        label="Add Contact"
                        primary
                        onTouchTap={this.showContactFields}
                      />
                    </CardActions>
                  )}
                </CardText>

                <CardTitle title="Association Opportunities *" />
                <CardText style={{ paddingTop: 0 }}>
                  <Checkbox
                    label="Are you interested in our Online Assessment Portal"
                    checked={onlinePortal}
                    onCheck={(_, check) => {
                      this.setState(() => ({
                        onlinePortal: check,
                      }));
                    }}
                  />

                  <SelectField
                    floatingLabelText="Partnership Type *"
                    fullWidth
                    value={partnership}
                    onChange={(_, index, value) => {
                      this.setState(() => ({
                        partnership: value,
                      }));
                    }}
                    errorText={partnershipErrorMessage}
                  >
                    <MenuItem
                      value="Campus Partner"
                      primaryText="Campus Partner"
                    />
                    <MenuItem
                      value="Endorsement Partner"
                      primaryText="Endorsement Partner"
                    />
                  </SelectField>

                  {partnership === 'Campus Partner' ? (
                    <div>
                      <CardTitle
                        title="Job Details"
                        subtitle={jobsErrorMessage}
                        subtitleColor={theme.accent1Color}
                        style={{ paddingLeft: 0 }}
                      />
                      <ContentContainer>
                        {/* console.log(jobs); */}
                        {jobs.map(job => (
                          <JobDetailCard
                            key={job.id}
                            {...job}
                            removeJob={this.removeJob}
                          />
                        ))}
                      </ContentContainer>
                      {jobShow ? (
                        <div>
                          <TextField
                            floatingLabelText="Job Title *"
                            hintText="Software Developer, IT Manager, Team Leader"
                            fullWidth
                            value={jobTitle}
                            onChange={(_, value) => {
                              this.setState(() => ({
                                jobTitle: value,
                              }));
                            }}
                            errorText={jobTitleErrorMessage}
                          />

                          <TextField
                            floatingLabelText="Job Description *"
                            hintText="Description about the job"
                            fullWidth
                            multiLine
                            value={jobDescription}
                            onChange={(_, value) => {
                              this.setState(() => ({
                                jobDescription: value,
                              }));
                            }}
                            errorText={jobDescriptionErrorMessage}
                          />

                          <TextField
                            floatingLabelText="Number of Requirements *"
                            hintText="Enter the number of requirements"
                            fullWidth
                            multiLine
                            value={requirements}
                            onChange={(_, value) => {
                              this.setState(() => ({
                                requirements: value,
                              }));
                            }}
                            errorText={requirementsErrorMessage}
                          />

                          <AutoComplete
                            floatingLabelText="Job Location *"
                            hintText="Enter the exact location to search"
                            dataSource={jobLocationDataSource}
                            fullWidth
                            onUpdateInput={(jobLocationSearchString) => {
                              this.setState(() => ({
                                jobLocationSearchText: jobLocationSearchString,
                                jobLocation: jobLocationSearchString,
                              }));
                              getLocations(jobLocationSearchString)
                                .then((data) => {
                                  this.setState(() => ({
                                    jobLocationDataSource: data,
                                  }));
                                })
                                .catch(() => {});
                            }}
                            dataSourceConfig={{
                              text: 'description',
                              value: 'place_id',
                            }}
                            filter={AutoComplete.fuzzyFilter}
                            onNewRequest={() => {
                              this.setLocation(this.state.jobLocation, 'job');
                            }}
                            errorText={jobLocationErrorMessage}
                            searchText={jobLocationSearchText}
                          />

                          <SelectField
                            floatingLabelText="Employment Type *"
                            fullWidth
                            value={employmentType}
                            onChange={(_, index, value) => {
                              this.setState(() => ({
                                employmentType: value,
                              }));
                            }}
                            errorText={employmentTypeErrorMessage}
                          >
                            <MenuItem
                              value="FTE"
                              primaryText="Full Time Employment"
                            />
                            <MenuItem
                              value="Internship"
                              primaryText="Internship"
                            />
                          </SelectField>

                          <TextField
                            floatingLabelText={
                              employmentType === 'Internship *'
                                ? 'Stipened*'
                                : 'Cost To Company*'
                            }
                            hintText="Enter numbers only"
                            fullWidth
                            value={ctc}
                            onChange={(_, value) => {
                              this.setState(() => ({
                                ctc: value,
                              }));
                            }}
                            errorText={ctcErrorMessage}
                          />

                          {employmentType === 'Internship' ? (
                            <SelectField
                              floatingLabelText="Duration of Internship *"
                              fullWidth
                              value={duration}
                              onChange={(_, index, value) => {
                                this.setState(() => ({
                                  duration: value,
                                }));
                              }}
                              errorText={durationErrorMessage}
                            >
                              <MenuItem
                                value="3 Months"
                                primaryText="3 Months"
                              />
                              <MenuItem
                                value="6 Months"
                                primaryText="6 Months"
                              />
                              <MenuItem value="1 Year" primaryText="1 Year" />
                            </SelectField>
                          ) : null}
                          <CardActions>
                            <RaisedButton
                              label="Save"
                              primary
                              onTouchTap={this.addJob}
                            />
                            <FlatButton
                              label="Cancel"
                              primary
                              onTouchTap={this.cancelJob}
                            />
                          </CardActions>
                        </div>
                      ) : (
                        <RaisedButton
                          label="Add Job"
                          primary
                          onTouchTap={this.showJobfields}
                        />
                      )}
                    </div>
                  ) : null}
                </CardText>
                <CardTitle title="Awards and Recognitions" />
                <CardText style={{ paddingTop: 0 }}>
                  <ContentContainer>
                    {awards.map(award => (
                      <Card key={award.id} style={{ position: 'relative' }}>
                        <CardHeader title={award.name} subtitle={award.year} />
                        <CardIcon>
                          <IconButton>
                            <CloseIcon
                              color={theme.primary1Color}
                              onTouchTap={() => {
                                this.removeAward(award.id);
                              }}
                            />
                          </IconButton>
                        </CardIcon>
                      </Card>
                    ))}
                  </ContentContainer>
                  {awardShow ? (
                    <div>
                      <TextFieldContainer>
                        <TextField
                          floatingLabelText="Name or Title"
                          hintText="Enter awards that your corporate have won."
                          style={{ width: '48%' }}
                          value={awardName}
                          onChange={(_, value) => {
                            this.setState(() => ({
                              awardName: value,
                            }));
                          }}
                          errorText={awardNameErrorMessage}
                        />

                        <TextField
                          floatingLabelText="Year of Receiving"
                          hintText="Enter numbers only"
                          style={{ width: '48%' }}
                          value={awardYear}
                          onChange={(_, value) => {
                            this.setState(() => ({
                              awardYear: value,
                            }));
                          }}
                          errorText={awardYearErrorMessage}
                        />
                      </TextFieldContainer>
                      <CardActions style={{ marginTop: '8px' }}>
                        <RaisedButton
                          label="Save"
                          primary
                          onTouchTap={this.addAward}
                        />
                        <FlatButton
                          label="Cancel"
                          primary
                          onTouchTap={this.cancelAward}
                        />
                      </CardActions>
                    </div>
                  ) : (
                    <CardActions style={{ marginTop: '8px' }}>
                      <RaisedButton
                        label="Add Award"
                        primary
                        onTouchTap={this.showAwardFields}
                      />
                    </CardActions>
                  )}

                  <TextField
                    floatingLabelText="Remarks"
                    hintText="Please mention any other details or any queries you might have."
                    fullWidth
                    multiLine
                    value={remarks}
                    onChange={(_, value) => {
                      this.setState(() => ({
                        remarks: value,
                      }));
                    }}
                  />
                </CardText>
                <CardActions>
                  <RaisedButton
                    label="Update"
                    primary
                    onTouchTap={() => {
                      if (!this.validateInfo()) {
                        this.openConfirmModal();
                      }
                    }}
                  />
                </CardActions>
              </Card>
            </ContentWrapper>
            <Dialog
              title="Update Company"
              modal
              actions={[
                <FlatButton
                  label="Cancel"
                  primary
                  onTouchTap={this.closeConfirmModal}
                />,
                <RaisedButton
                  label="Submit"
                  primary
                  onTouchTap={() => {
                    this.updateCorporate();
                  }}
                />,
              ]}
              open={confirmModalOpen}
              onRequestClose={this.closeConfirmModal}
            >
              <CardText>
                Please confirm the data that you have filled. Are you sure?
              </CardText>
            </Dialog>
          </div>
        )}
      </div>
    );
  }
}

EarlyBirdCorporateEdit.propTypes = {
  match: PropTypes.object.isRequired, // eslint-disable-line
  history: PropTypes.object.isRequired, // eslint-disable-line
};

export default EarlyBirdCorporateEdit;



// WEBPACK FOOTER //
// ./src/views/EarlyBirdCorporate/EarlyBirdCorporateEdit.js